DESIGN_TEMPLATES.push(...[
  {
    "key": "nk127",
    "sku": "NK-127",
    "name": "Birth Month Flower",
    "category": "family",
    "description": "Birth Month Flower",
    "canvasSize": 1476,
    "version": "psd1476-20261104",
    "thumbnail": "mr-design-tile-nk127.webp",
    "fixedTexture": "mr-fixed-nk127-129-empty.webp",
    "fields": [
      {
        "key": "name",
        "label": "Name",
        "value": "Madeline",
        "prefix": "",
        "font": "Angelta Script",
        "fontFile": "AngeltaScript.otf",
        "fontPostScript": "AngeltaScript",
        "size": 120.0,
        "transform": [
          0.5562446193316466,
          0.0,
          0.0,
          0.5562446193316459,
          740.4938128465976,
          1158.700548917134
        ],
        "bbox": [
          598.518,
          1092.978,
          883.386,
          1159.398
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 384.57,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "motif",
        "label": "Birth month flower",
        "asset": "mr-choice-flower-01.webp",
        "bbox": [
          670.104,
          919.548,
          813.276,
          1092.978
        ]
      }
    ],
    "motifLabel": "Birth month flower",
    "motifOptions": [
      {
        "value": "flower-01",
        "label": "January - Carnation",
        "asset": "mr-choice-flower-01.webp",
        "bbox": [
          670.104,
          919.548,
          813.276,
          1092.978
        ]
      },
      {
        "value": "flower-02",
        "label": "February - Violet",
        "asset": "mr-choice-flower-02.webp",
        "bbox": [
          557.1899999999999,
          725.454,
          774.162,
          960.876
        ]
      },
      {
        "value": "flower-03",
        "label": "March - Daffodil",
        "asset": "mr-choice-flower-03.webp",
        "bbox": [
          549.81,
          675.27,
          782.28,
          1009.584
        ]
      },
      {
        "value": "flower-04",
        "label": "April - Sweet Pea",
        "asset": "mr-choice-flower-04.webp",
        "bbox": [
          586.71,
          749.0699999999999,
          744.6419999999999,
          938.736
        ]
      },
      {
        "value": "flower-05",
        "label": "May - Lily of the Valley",
        "asset": "mr-choice-flower-05.webp",
        "bbox": [
          569.736,
          724.716,
          760.878,
          961.614
        ]
      },
      {
        "value": "flower-06",
        "label": "June - Rose",
        "asset": "mr-choice-flower-06.webp",
        "bbox": [
          569.736,
          733.572,
          760.878,
          953.496
        ]
      },
      {
        "value": "flower-07",
        "label": "July - Larkspur",
        "asset": "mr-choice-flower-07.webp",
        "bbox": [
          567.522,
          678.222,
          763.83,
          1008.846
        ]
      },
      {
        "value": "flower-08",
        "label": "August - Poppy",
        "asset": "mr-choice-flower-08.webp",
        "bbox": [
          566.784,
          721.764,
          764.568,
          964.566
        ]
      },
      {
        "value": "flower-09",
        "label": "September - Aster",
        "asset": "mr-choice-flower-09.webp",
        "bbox": [
          552.024,
          704.052,
          779.328,
          981.54
        ]
      },
      {
        "value": "flower-10",
        "label": "October - Cosmos",
        "asset": "mr-choice-flower-10.webp",
        "bbox": [
          540.954,
          686.34,
          790.398,
          997.776
        ]
      },
      {
        "value": "flower-11",
        "label": "November - Chrysanthemum",
        "asset": "mr-choice-flower-11.webp",
        "bbox": [
          564.5699999999999,
          726.93,
          766.044,
          958.662
        ]
      },
      {
        "value": "flower-12",
        "label": "December - Paperwhite Narcissus",
        "asset": "mr-choice-flower-12.webp",
        "bbox": [
          579.33,
          723.24,
          752.76,
          963.09
        ]
      }
    ]
  },
  {
    "key": "nk128",
    "sku": "NK-128",
    "name": "Handwritten Note",
    "category": "family",
    "description": "Handwritten Note",
    "canvasSize": 1476,
    "version": "psd1476-20261104",
    "thumbnail": "mr-design-tile-nk128.webp",
    "fixedTexture": "mr-fixed-nk127-129-empty.webp",
    "fields": [
      {
        "key": "line1",
        "label": "First line",
        "value": "Never Drunk",
        "prefix": "",
        "font": "Bradley Hand",
        "fontFile": "BradleyHand-Bold.ttf",
        "fontPostScript": "BradleyHandITCTT-Bold",
        "size": 60.0,
        "transform": [
          1.5535202315645567,
          -0.11465249376934872,
          0.11465249376934895,
          1.5535202315645567,
          1050.9963113789845,
          1145.7982440543042
        ],
        "bbox": [
          771.948,
          1068.624,
          1337.256,
          1267.146
        ],
        "align": "center",
        "tracking": 50.0,
        "caps": 0,
        "maxWidth": 763.17,
        "maxLength": 48
      },
      {
        "key": "line2",
        "label": "Second line",
        "value": "In New York",
        "prefix": "",
        "font": "Bradley Hand",
        "fontFile": "BradleyHand-Bold.ttf",
        "fontPostScript": "BradleyHandITCTT-Bold",
        "size": 60.0,
        "transform": [
          1.5535202315645567,
          -0.11465249376934872,
          0.11465249376934895,
          1.5535202315645567,
          1058.1289335918457,
          1242.4439649409182
        ],
        "bbox": [
          771.948,
          1068.624,
          1337.256,
          1267.146
        ],
        "align": "center",
        "tracking": 50.0,
        "caps": 0,
        "maxWidth": 763.17,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [],
    "motifLabel": "",
    "motifOptions": []
  },
  {
    "key": "nk129",
    "sku": "NK-129",
    "name": "Christmas Tree",
    "category": "family",
    "description": "Christmas Tree",
    "canvasSize": 1476,
    "version": "psd1476-20261104",
    "thumbnail": "mr-design-tile-nk129.webp",
    "fixedTexture": "mr-fixed-nk127-129-empty.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "THE COLONS",
        "prefix": "",
        "font": "Playfair Display",
        "fontFile": "PlayfairDisplay-Regular.ttf",
        "fontPostScript": "PlayfairDisplay-Regular",
        "size": 92.5,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          552.7018697440856,
          920.2633933485957
        ],
        "bbox": [
          344.646,
          871.578,
          759.402,
          921.762
        ],
        "align": "center",
        "tracking": 0.0,
        "caps": 0,
        "maxWidth": 559.92,
        "maxLength": 48
      },
      {
        "key": "year",
        "label": "Year",
        "value": "2026",
        "prefix": "",
        "font": "Bodoni Bk BT",
        "fontFile": "BodoniBT-Book.ttf",
        "fontPostScript": "BodoniBT-Book",
        "size": 60.0,
        "transform": [
          0.7288818532818532,
          0.0,
          0.0,
          0.7288818532818532,
          555.0123405288185,
          987.6046457123754
        ],
        "bbox": [
          508.48199999999997,
          959.4,
          600.732,
          988.182
        ],
        "align": "center",
        "tracking": 50.0,
        "caps": 0,
        "maxWidth": 124.54,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "motif",
        "label": "Christmas tree",
        "asset": "mr-choice-tree-1.webp",
        "bbox": [
          328.40999999999997,
          292.986,
          780.804,
          831.726
        ]
      }
    ],
    "motifLabel": "Christmas tree",
    "motifOptions": [
      {
        "value": "tree-1",
        "label": "Tree 1",
        "asset": "mr-choice-tree-1.webp",
        "bbox": [
          328.40999999999997,
          292.986,
          780.804,
          831.726
        ]
      },
      {
        "value": "tree-2",
        "label": "Tree 2",
        "asset": "mr-choice-tree-2.webp",
        "bbox": [
          270.108,
          264.942,
          763.092,
          858.294
        ]
      },
      {
        "value": "tree-3",
        "label": "Tree 3",
        "asset": "mr-choice-tree-3.webp",
        "bbox": [
          355.716,
          311.436,
          748.332,
          852.39
        ]
      },
      {
        "value": "tree-4",
        "label": "Tree 4",
        "asset": "mr-choice-tree-4.webp",
        "bbox": [
          387.45,
          329.88599999999997,
          720.288,
          828.036
        ]
      }
    ]
  }
]);
